import css from "./memory.module.scss";

// The skeleton copies the real card silhouette line for line, so the list does
// not reflow when the data lands.
const LINES = [
  [css.boneLineFull, css.boneLineShort],
  [css.boneLineFull, css.boneLineWide, css.boneLineShort],
  [css.boneLineWide],
  [css.boneLineFull, css.boneLineShort],
];

// On first load it also stands in for the closed settings row. On a new search
// or sort the real settings are already on screen, so only cards are drawn.
export default function MemorySkeleton({ cardsOnly = false }) {
  return (
    <div className={css.skeletonGroup} aria-hidden="true">
      {!cardsOnly && (
        <div className={css.shell}>
          <div className={css.core}>
            <div className={css.settingRow}>
              <span className={`${css.bone} ${css.boneLineWide}`} />
              <span className={`${css.bone} ${css.boneAction}`} />
            </div>
          </div>
        </div>
      )}
      {LINES.map((widths, index) => (
        <div
          key={index}
          className={`${css.shell} ${css.skelCard}`}
          style={{ "--mem-index": index }}
        >
          <div className={`${css.core} ${css.skelCore}`}>
            <div className={css.skelRow}>
              <span className={`${css.bone} ${css.boneChip}`} />
              <span className={`${css.bone} ${css.boneChipSmall}`} />
              <span
                className={`${css.bone} ${css.boneDate} ${css.skelSpacer}`}
              />
            </div>
            {widths.map((width, line) => (
              <span key={line} className={`${css.bone} ${width}`} />
            ))}
            <div className={css.skelRow}>
              <span className={`${css.bone} ${css.boneAction}`} />
              <span className={`${css.bone} ${css.boneAction}`} />
              <span
                className={`${css.bone} ${css.boneActionWide} ${css.skelSpacer}`}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
